import { useState } from 'react'
import { Tab } from 'react-bootstrap';
import EmailUser from "./EmailUser";
// import MobileUser from './MobileUser'
import loginlogo from '../styles/webroot/images/login_logo.png'
import ReactSlider from '@src/common/ReactSlider';


const loginLeft = {
    backgroundImage: `url("/images/login_bg_pattern.png")`,
    backgroundColor: "#008CF0",
    backgroundRepeat: "repeat-y",
    backgroundPosition: "center",
    borderRadius: "25px"
}


function Login() {
    // eslint-disable-next-line
    const [showCaptcha, setShowCaptcha] = useState(0);
    // eslint-disable-next-line
    const [showMobileLinks, setShowMobileLinks] = useState(true);
    // eslint-disable-next-line
    const [showEmailLinks, setShowEmailLinks] = useState(true);

    // const activeTabHandler = () => {
    //     setShowCaptcha((prev) => prev + 1);
    // }
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="login-outer">
                    <div className="login-left-panel slider-left-pannel-web" style={loginLeft}>
                        <div className="login-bg" style={{background: "none"}}>
                            <div className="login-txt t-center t-center ocr-login-left">
                                <span >Welcome.</span>
                                <h1 > Please sign in to Zen Insure</h1>
                            </div>
                            <ReactSlider screenType="Login"></ReactSlider>
                        </div>
                    </div>
                    <div className="login-right-panel t-center">
                        <div className="logo-img">
                            <img src={loginlogo} className="" alt='logo' />
                        </div>
                        <div className="login-heading m-md-t">
                            <h2>Sign In</h2>
                        </div>
                        <div className="p-lg-t t-center">
                            <label>Enter your credentials to access your account</label>
                        </div>
                        <Tab.Container id="" defaultActiveKey="first">
                            <div className="login-tab">

                                {/* <Nav variant="pills" className="flex-column" onSelect={() => activeTabHandler()}>
                                    {(showEmailLinks && showMobileLinks) &&

                                        <Nav.Item>
                                            <Nav.Link eventKey="first">By Email</Nav.Link>
                                        </Nav.Item>
                                    }
                                    {(showEmailLinks && showMobileLinks) &&
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">By Mobile</Nav.Link>
                                        </Nav.Item>
                                    }
                                </Nav> */}


                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <EmailUser setShowEmailLinks = {setShowEmailLinks} setShowMobileLinks = {setShowMobileLinks} />

                                    </Tab.Pane>
                                    {/* <Tab.Pane eventKey="second">
                                        <MobileUser setShowEmailLinks = {setShowEmailLinks} setShowMobileLinks = {setShowMobileLinks}  showCaptcha={showCaptcha} />
                                    </Tab.Pane> */}
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login